export const invoicesDataGrid = {
  '& .MuiDataGrid-cell': {
    alignContent: 'center',
    lineHeight: 'unset !important',
    cursor: 'pointer'
  },
  '& .MuiDataGrid-cellContent': {
    textOverflow: 'ellipsis !important',
    textAlign: 'left !important'
  }
};

export const exportableContainerStyles = {
  width: '24px',
  height: '24px',
  display: 'inline-block'
};

export const exportableStyles = {
  borderRadius: '22px',
  width: '10px',
  height: '10px',
  display: 'inline-block'
};

export const exportableSignStyles = {
  backgroundColor: 'rgb(87, 202, 34)'
};

export const notExportableSignStyles = {
  backgroundColor: 'rgb(255, 25, 67)'
};

export const exportableIconContainerStyles = {
  display: 'flex',
  borderRadius: '24px',
  background: '#cae2f9'
};

export const exportableIconStyles = {
  color: '#1976d2'
};

export const severityPillRootStyles = {
  borderRadius: 6,
  fontSize: '0.75rem',
  fontWeight: 500,
  padding: '0.125rem 0.375rem',
  display: 'inline-flex',
  alignItems: 'center'
};

export const separatorBoxStyles = {
  width: '0.1875rem',
  height: '0.1875rem',
  borderRadius: '50%',
  backgroundColor: '#ffffff'
};

export const gateNameTextStyles = {
  fontSize: '0.75rem',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  display: 'block',
  maxWidth: '280px',
  wordBreak: 'normal'
};
